/**
 * @class
 * @description Wrapper class that injects our modified Theoplayer loader in a Theoplayer instance.
 * @exports Theoplayer
 */
export default class TheoPlayerInterceptor {
    constructor(player, cdnBalancer) {
        this._iso_8859_15_table = { 338: 188, 339: 189, 352: 166, 353: 168, 376: 190, 381: 180, 382: 184, 8364: 164 };
        this._player = player;
        this._cdnBalancer = cdnBalancer;
    }
    load() {
        if (this._player && this._cdnBalancer) {
            this.addRequestInterceptor();
            this.addResponseInterceptor();
        }
    }
    iso_8859_15_to_uint8array(iso_8859_15_str) {
        let buf = new ArrayBuffer(iso_8859_15_str.length);
        let bufView = new Uint8Array(buf);
        for (let i = 0, strLen = iso_8859_15_str.length; i < strLen; i++) {
            let octet = iso_8859_15_str.charCodeAt(i);
            if (this._iso_8859_15_table.hasOwnProperty(octet))
                octet = this._iso_8859_15_table[octet];
            bufView[i] = octet;
            if (octet < 0 || 255 < octet)
                console.error(`invalid data error`);
        }
        return bufView;
    }
    addResponseInterceptor() {
        this._player.network.addResponseInterceptor(response => {
            let urlToTest = (response.request.url).split("?")[0];
            let originalUrl = this._cdnBalancer.getLoader().getSegmentOriginalUrl(urlToTest);
            let segment;
            if (originalUrl) {
                segment = this._cdnBalancer.getLoader().getSegment(originalUrl.toString());
            }
            if (segment != undefined && originalUrl) {
                if (response.status >= 300 || response.status < 200) {
                    this._cdnBalancer.getLoader().onProcessSegmentFail(segment, false);
                    let isDone = false;
                    let i = 0;
                    while (!isDone && i < 5) {
                        i++;
                        const request = new XMLHttpRequest();
                        try {
                            request.overrideMimeType('text/plain; charset=ISO-8859-15');
                            request.open('GET', originalUrl === null || originalUrl === void 0 ? void 0 : originalUrl.toString(), false); // `false` makes the request synchronous
                            request.send(null);
                            if (request.status >= 200 && request.status <= 300) {
                                isDone = true;
                                var uint8array = this.iso_8859_15_to_uint8array(request.responseText);
                                response.respondWith({
                                    body: uint8array,
                                    status: 200,
                                    statusText: 'OK',
                                    closed: true,
                                });
                                // done();
                            }
                        }
                        catch (error) {
                        }
                    }
                }
                else {
                    let ok = segment.onSuccess(response.body);
                    if (ok) {
                        this._cdnBalancer.getLoader().onProcessSegmentSuccess(segment);
                    }
                    else {
                        this._cdnBalancer.getLoader().onProcessSegmentFail(segment, false);
                    }
                }
            }
        });
    }
    addRequestInterceptor() {
        this._player.network.addRequestInterceptor(request => {
            let urlTest = request.url;
            let splitted = urlTest.split('?');
            urlTest = splitted[0];
            let urlObject = new URL(urlTest);
            let newUrl = this._cdnBalancer.simpleRequest(urlObject);
            if (newUrl == undefined || newUrl === '') {
                newUrl = request.url;
            }
            else {
                let params;
                if (splitted.length > 1)
                    params = splitted[1];
                newUrl = newUrl.trim();
                if (params) {
                    if (newUrl.includes("?")) {
                        newUrl = newUrl + "&" + params;
                    }
                    else {
                        newUrl = newUrl + "?" + params;
                    }
                }
            }
            request.redirect({
                url: newUrl,
                method: request.method,
                headers: request.headers,
                closed: request.closed,
                useCredentials: request.useCredentials,
                type: request.type,
                subType: request.subType,
                responseType: request.responseType,
                body: request.body
            });
        });
    }
}
